import { RiEditFill } from '@remixicon/react'
import { useState } from 'react'

import type { Detail } from '@/api/orders/orders-types'
import { ImageCanvas } from '@/components/image-canvas/image-canvas'
import { Button } from '@/components/ui/button'
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog'
import { cn } from '@/lib/utils'

interface ImageEditPopupProps {
  className?: string
  data: Detail
}

export const ImageEditPopup = ({ className, data }: ImageEditPopupProps) => {
  const [open, setOpen] = useState(false)
  return (
    <Dialog
      modal={false}
      open={open}
      onOpenChange={setOpen}
    >
      <DialogTrigger asChild>
        <Button
          onClick={(e) => e.stopPropagation()}
          className={cn(className)}
          variant='ghost'
          size='icon-sm'
        >
          <RiEditFill />
        </Button>
      </DialogTrigger>
      {open ? (
        <div className='data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 bg-black-200/20 fixed inset-0 z-50 backdrop-blur-xs' />
      ) : null}
      <DialogContent
        onInteractOutside={(e) => {
          if (e.target instanceof HTMLElement && e.target.getAttribute('data-fabric') === 'textarea') {
            e.preventDefault()
          }
        }}
        className='h-150 !max-w-233'
        onOpenAutoFocus={(e) => e.preventDefault()}
        onClick={(e) => e.stopPropagation()}
      >
        <DialogHeader className='sr-only'>
          <DialogTitle className='sr-only'>Image edit</DialogTitle>
        </DialogHeader>
        <ImageCanvas data={data} />
      </DialogContent>
    </Dialog>
  )
}
